// /* eslint-disable import/first */
// ConstrainedToolTip
import _ERROR_OUTLINE from "../assets/images/custom_icons/search/error-outline.svg";
export var ERROR_OUTLINE = _ERROR_OUTLINE;

// RP Email Error Icon
import _EMAIL_ERROR_ICON from "../assets/images/email_error_icon.svg";
export var EMAIL_ERROR_ICON = _EMAIL_ERROR_ICON;
import _FULFILL_DOCUMENT_IMPORTED from "../assets/images/custom_icons/requirements/Document.png";
export var FULFILL_DOCUMENT_IMPORTED = _FULFILL_DOCUMENT_IMPORTED;
import _FULFILL_PAYMENT_IMPORTED from "../assets/images/custom_icons/requirements/Payment.png";
export var FULFILL_PAYMENT_IMPORTED = _FULFILL_PAYMENT_IMPORTED;
import _FULFILL_QUESTIONS_IMPORTED from "../assets/images/custom_icons/requirements/Question.png";
export var FULFILL_QUESTIONS_IMPORTED = _FULFILL_QUESTIONS_IMPORTED;
import _ICON_INTERNAL_IMPORTED from "../assets/images/custom_icons/requirements/Internal.png";
export var ICON_INTERNAL_IMPORTED = _ICON_INTERNAL_IMPORTED;
import _RECEIPT_ICON from "../assets/images/custom_icons/requirements/ReceiptIcon.svg";
export var RECEIPT_ICON = _RECEIPT_ICON;
import _MISSING_ICON from "../assets/images/custom_icons/requirements/MissingIcon.png";
export var MISSING_ICON = _MISSING_ICON;
import _REVIEWING_ICON from "../assets/images/custom_icons/requirements/ReviewingIcon.png";
export var REVIEWING_ICON = _REVIEWING_ICON;
import _NOT_APPROVED_ICON from "../assets/images/custom_icons/requirements/NotApprovedIcon.png";
export var NOT_APPROVED_ICON = _NOT_APPROVED_ICON;
import _APPROVED_ICON from "../assets/images/custom_icons/requirements/ApprovedIcon.png";
export var APPROVED_ICON = _APPROVED_ICON;
import _APPLYPROOF_VERIFIED_ICON from "../assets/images/verify_icon.svg";
export var APPLYPROOF_VERIFIED_ICON = _APPLYPROOF_VERIFIED_ICON;
import _APPLYPROOF_ERROR_ICON from "../assets/images/applyproof_fail_icon.svg";
export var APPLYPROOF_ERROR_ICON = _APPLYPROOF_ERROR_ICON;
import _APPLYPROOF_INVALID_ICON from "../assets/images/applyproof_invalid.svg";
export var APPLYPROOF_INVALID_ICON = _APPLYPROOF_INVALID_ICON;
import _APPLICATION_STATUS from "../assets/images/custom_icons/student_records/Application_Status.svg";
export var APPLICATION_STATUS = _APPLICATION_STATUS;
import _APPLYPROOF_BADGE from "../assets/images/custom_icons/student_records/ApplyProof_Badge.svg";
export var APPLYPROOF_BADGE = _APPLYPROOF_BADGE;
import _APPLYPROOF_ICON from "../assets/images/custom_icons/student_records/ApplyProof_Icon.svg";
export var APPLYPROOF_ICON = _APPLYPROOF_ICON;
import _DOCUMENT_TYPE_ICON from "../assets/images/custom_icons/student_records/Document_Type_icon.svg";
export var DOCUMENT_TYPE_ICON = _DOCUMENT_TYPE_ICON;
import _DOWNLOAD_ICON from "../assets/images/custom_icons/student_records/Download_icon.svg";
export var DOWNLOAD_ICON = _DOWNLOAD_ICON;
import _PAYMENT_TYPE_ICON from "../assets/images/custom_icons/student_records/dollar-sign-solid.svg";
export var PAYMENT_TYPE_ICON = _PAYMENT_TYPE_ICON;
import _QUESTION_ANSWER_ICON from "../assets/images/custom_icons/student_records/Question_Answer_Icon.svg";
export var QUESTION_ANSWER_ICON = _QUESTION_ANSWER_ICON;
import _ROCKET_SHIP_ICON from "../assets/images/custom_icons/student_records/RocketShipIcon.png";
export var ROCKET_SHIP_ICON = _ROCKET_SHIP_ICON;
import _TIMELINE_RECENT_VIEW from "../assets/images/custom_icons/student_records/Timeline_Recent_view.svg";
export var TIMELINE_RECENT_VIEW = _TIMELINE_RECENT_VIEW;
import _TIMELINE_BULLET from "../assets/images/custom_icons/student_records/Timeline_bullet.svg";
export var TIMELINE_BULLET = _TIMELINE_BULLET;
import _STUDENT_RECORDS_ICON from "../assets/images/custom_icons/student_records/student_records_icon.svg";
export var STUDENT_RECORDS_ICON = _STUDENT_RECORDS_ICON;
import _STUDENT_RECORDS_ICON_WHITE from "../assets/images/custom_icons/student_records/student_records_icon_white.svg";
export var STUDENT_RECORDS_ICON_WHITE = _STUDENT_RECORDS_ICON_WHITE;
import _NON_PREMIUM_USER from "../assets/images/non_premium_user.svg";
export var NON_PREMIUM_USER = _NON_PREMIUM_USER;
import _PREMIUM_STAR from "../assets/images/premium_star.svg";
export var PREMIUM_STAR = _PREMIUM_STAR;